module.exports = __webpack_public_path__ + "05d41d06ee4cd2ec86401b10440f12ee.png";